import { render, staticRenderFns } from "./Pedidov2.vue?vue&type=template&id=4c645126&"
import script from "./Pedidov2.vue?vue&type=script&lang=js&"
export * from "./Pedidov2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports